import axios from 'axios';
import { apiUrl } from '@/utils/config';
import { PimcoreEntityLayout } from '@/types/entity';
// import http from './api';

const getEntityLayout = async (entityName: string): Promise<PimcoreEntityLayout[]> => {
  try {
    const { data } = await axios.get(`${apiUrl}pimcore/layouts?className=${entityName}`);
    return data.resp?.data?.other || [];
  } catch (error) {
    console.error(error.message);
    return [];
  }
};

export {
  getEntityLayout,
};
